<template>
	<div
		class="py-3 sm:py-5 lg:py-5 py-5 bg-gray-100 flex flex-col space-y-2"
		:class="{ 'opacity-50': disabled }"
	>
		<div class="flex justify-between py-4">
			<h3 class="text-2xl md:text-4xl font-semibold">Ernte {{ year }}</h3>
			<ui-button
				class="flex items-center ml-5 px-4 py-1"
				:disabled="disabled"
				v-on:click="
					$bus.$emit('modal:open', {
						view: {
							dataUrl: $route('sale_intentions.update'),
							view: 'views/SaleIntention/Form',
							data: { product__harvest: year }
						},
						cta: {
							code: 402,
							view: 'views/Modal/PremiumRequired'
						}
					})
				"
			>
				<ui-icon name="plus" class="h-5 w-5 mr-2" stroke-width="2" />
				Neue Fruchtart
			</ui-button>
		</div>

		<div v-if="saleIntentions.length > 0" class="flex py-4">
			<div class="w-full">
				<div
					class="flex bg-gray-500 text-white text-base rounded-t-lg font-semibold"
				>
					<div
						class="p-3 text-left flex items-center flex-grow w-[17.5%] min-w-16 sm:min-w-24 sm:max-w-28 md:min-w-24 md:max-w-[15%]"
					>
						Fruchtart
					</div>

					<div
						class="hidden sm:flex p-3 flex items-center flex-grow w-[35%] min-w-24 sm:max-w-[20%] md:min-w-24"
					>
						Status
					</div>

					<div
						class="hidden sm:flex p-3 items-center basis-1/12 flex-grow min-w-22 sm:min-w-24 sm:max-w-[11%] pl-3 lg:pl-5"
					>
						<div class="flex flex-wrap text-left">
							<span class="basis-2/3">Menge</span>
							<span class="basis-2/3 text-xs font-normal">Gesamt</span>
						</div>
					</div>

					<div
						class="p-3 text-right basis-1/12 flex items-center flex-grow hidden sm:flex sm:min-w-22 md:min-w-22 sm:max-w-[11%]"
					>
						<div class="flex flex-wrap text-left">
							<span class="basis-2/3">Menge</span>
							<span class="basis-2/3 text-xs font-normal">Verkauft</span>
						</div>
					</div>

					<div
						class="p-3 text-right basis-1/12 flex items-center flex-grow sm:min-w-22 md:min-w-22 sm:max-w-[11%]"
					>
						<div class="flex flex-wrap text-left">
							<span class="basis-2/3">Menge</span>
							<span class="basis-2/3 text-xs font-normal">Offen</span>
						</div>
					</div>

					<div
						class="p-3 basis-1/12 flex flex-grow items-center hidden sm:flex sm:min-w-24 sm:max-w-[15%]"
					>
						&#8709;-Erlös
					</div>

					<!-- Best Price -->
					<div
						class="p-3 basis-1/12 flex flex-grow items-center sm:min-w-24 md:min-w-28 sm:max-w-[15%]"
					>
						Heute Bestpreis!
					</div>

					<!-- Buttons -->
					<div
						class="p-3 basis-1/12 flex-shrink-0 md:flex-grow min-w-15 sm:min-w-15 sm:max-w-24 md:min-w-22"
					></div>
				</div>
				<div class="bg-white border border-gray-400 rounded-b-lg">
					<row
						v-for="(item, index) in saleIntentions"
						v-bind:key="`${item.product__harvest}-${item.product_grade_id}`"
						v-bind="item"
						:first="index === 0"
						:last="!saleIntentions[index + 1]"
						:disabled="disabled"
					/>
				</div>
			</div>
		</div>
		<div v-else>
			<p>
				Starten Sie hier Ihr Vermarktungsmanagement für die Ernte {{ year }}
			</p>
		</div>
	</div>
</template>
<script lang="ts">
import Row from "./Row.vue";

export default {
	components: {
		Row,
	},
	props: {
		year: {
			required: true,
			type: Number,
		},
		saleIntentions: {
			required: true,
		},
		disabled: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
};
</script>
